import type { VoidFunctionComponent } from 'react';
import type Stripe from 'stripe';

import { plural } from '../../../../shared/helpers';
import { GreenCheck } from '../../generic';
import Flex from '../../generic/Flex';
import { ICON_SIZE } from '../../generic/Icon/icon-constants';

import { getLimitDisplayValue, isEnterprisePlan } from './utils';

import styles from './style.module.less';

type LimitsComponentProps = {
  product: Stripe.Product,
};

const getLimitsTitle = (product: Stripe.Product) => {
  if (isEnterprisePlan(product)) {
    return 'No limits';
  }
  return 'Limits';
};

const LimitsComponent: VoidFunctionComponent<LimitsComponentProps> = ({
  product,
}) => {
  const projectValue = getLimitDisplayValue(product?.metadata?.limit_projects);
  const cdtValue = getLimitDisplayValue(product?.metadata?.limit_contributors);
  const rgValue = getLimitDisplayValue(product?.metadata?.limit_release_groups);
  const limits = [
    {
      label: plural(Number(projectValue), 'project'),
      value: projectValue,
    },
    {
      label: plural(Number(cdtValue), 'contributing developer'),
      value: cdtValue,
    },
    {
      label: plural(Number(rgValue), 'release group'),
      value: rgValue,
    },
    {
      label: 'dependency depth for scans',
      value: getLimitDisplayValue('unlimited'),
    },
    {
      label: 'Fully unlocked quality checks',
      value: '',
    },
    {
      label: plural(Number(projectValue), 'imported SBOM'),
      value: projectValue,
    },
  ];

  return (
    <div className={styles.limitsContainer}>
      <div className={styles.limitsTitle}>
        {getLimitsTitle(product)}
      </div>
      {limits.map((limit) => {
        return (
          <div key={limit.label} className={styles.limitItem}>
            <Flex justify="flex-start" align="flex-start" gap={12}>
              <GreenCheck size={ICON_SIZE.LG} />
              <div>{limit.value} {limit.label}</div>
            </Flex>
          </div>
        );
      })}
    </div>
  );
};

type LimitsComponentForStaticPlanProps = {
  list: string[],
};
export const LimitsComponentForStaticPlan: VoidFunctionComponent<LimitsComponentForStaticPlanProps> = ({
  list,
}) => {
  return (
    <div className={styles.limitsContainer}>
      <div className={styles.limitsTitle}>
        Details
      </div>
      {list.map((item) => {
        return (
          <div key={item} className={styles.limitItem}>
            <Flex justify="flex-start" align="flex-start" gap={12}>
              <GreenCheck size={ICON_SIZE.LG} />
              <div>{item}</div>
            </Flex>
          </div>
        );
      })}
    </div>
  );
};

export default LimitsComponent;
